<template>
  <div class="video-block impact-module">
    <div class="inner">
      <div v-if="data.has_border" class="border"></div>

      <flex-header>
        <template v-slot:flex>
          <button
            v-if="data.placeholder.poster && data.embed && !videoActive"
            :class="['media-wrap', 'playhead', 'poster-image', { contain: data.placeholder.uncropped }]"
            @click="videoActive = true"
            title="Watch Trailer"
          >
            <img :src="data.placeholder.poster" />

            <div class="poster-titles">
              <h2 v-if="data.title">{{ data.title }}</h2>
              <div v-if="data.text" v-html="data.text"></div>
            </div>

            <div v-if="data.title || data.text" class="title-gradient"></div>
          </button>
          <div v-else-if="data.placeholder.poster && data.embed && videoActive" class="media-wrap">
            <iframe
              :src="embedSrc"
              width="640"
              height="360"
              frameborder="0"
              webkitallowfullscreen
              mozallowfullscreen
              allowfullscreen
            ></iframe>
          </div>
        </template>
      </flex-header>
    </div>
  </div>
</template>

<script>
import FlexHeader from '@/components/FlexHeader'

export default {
  name: 'VideoBlock',
  components: { FlexHeader },
  props: {
    data: Object,
  },
  data() {
    return {
      videoActive: false,
    }
  },
  computed: {
    embedSrc() {
      if (this.data && this.data.embed) {
        if (this.data.embed.type === 'vimeo') {
          return `https://player.vimeo.com/video/${this.data.embed.id}?autoplay=1`
        }
        if (this.data.embed.type === 'youtube') {
          return `https://youtube.com/embed/${this.data.embed.id}?autoplay=1`
        }
      }
      return false
    },
  },
}
</script>

<style scoped>
.video-block > .inner {
  /* padding: 4rem 0; */
}

.media-wrap {
  width: 100%;
  height: 100%;
  position: relative;
}

button.media-wrap {
  -webkit-appearance: none;
  -moz-appearance: none;
  border: none;
  background: none;
  cursor: pointer;
}

button.media-wrap.focus-visible {
  border: 1px dashed #fff;
}

.media-wrap iframe {
  position: absolute;
  top: 10%;
  left: 10%;
  height: 80%;
  width: 80%;
}

.media-wrap img {
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  opacity: 0.8;
}

.media-wrap.contain img {
  object-fit: contain;
}

.media-wrap.playhead::after {
  content: 'Watch';
  font: var(--nord);
  text-transform: uppercase;
  width: 20rem;
  height: 14rem;
  background-image: url(~@/assets/playhead.svg);
  background-size: 8.5rem;
  background-repeat: no-repeat;
  background-position: top center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  text-align: center;
  color: #fff;
}

.poster-image {
  position: relative;
}

.poster-titles {
  position: absolute;
  bottom: 0px;
  left: 0px;
  padding: 4rem;
  color: white;
  z-index: 10;
  width: 50%;
}

.poster-titles h2 {
  font: var(--nord-title);
}

.poster-titles div {
  font: var(--serif-small);
  margin-top: 1rem;
}

.title-gradient {
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 130px;
  background: linear-gradient(0deg, black, transparent);
}

.video-block::v-deep .flex-header .flex {
  border: 1px dashed white;
}

@media (max-width: 1000px) {
  /**
  * Media
  */

  .media-wrap.playhead::after {
    content: '';
    height: 6.5rem;
    background-size: contain;
  }

  .media-wrap iframe {
    width: 90%;
    left: 5%;
  }

  .poster-titles {
    padding: 2rem;
    width: 100%;
  }
}
</style>
